module.exports = __webpack_public_path__ + "img/header_bg_t.7a770e07.jpg";